/**
 * CPAYMENT-1731: предупреждение «времени почти не осталось» на экране реквизитов.
 *
 * Клиент, который уже перевёл деньги и ушёл в приложение банка за чеком, не смотрит на таймер —
 * он возвращается на страницу с уже истёкшим тикетом. Попап за 2 минуты до конца даёт ему
 * единственное действие, которое ещё что-то меняет: отметить «я плачу» и получить продлённое окно.
 *
 * Показывать его можно только там, где продление реально произойдёт, иначе он обещает время,
 * которого не будет:
 *  - `simpleConfirmation === false` — клиенту нужен чек. Это же условие отсекает не-матчинг:
 *    бэкенд отдаёт таким тикетам `simpleConfirmation = true` безусловно
 *    (`DTOPaymentRequestResponse::prepare`), а короткое окно есть только у матчинга;
 *  - `receiptIntent` ещё не стоит — отметка одноразовая, на продлённом окне продлевать нечего.
 *
 * Решение живёт здесь, рядом с `stateTimeout`: шаблоны получают готовый флаг и только рисуют.
 */

/** Порог показа: столько секунд остаётся на таймере, когда открывается попап. */
export const LOW_TIME_WARNING_SEC = 120;

/** Статусы, на которых клиент видит реквизит и может отметить переход к чеку. */
const REQUISITE_STATUSES = ['PAYMENT_PENDING', 'WAITING_FOR_SMS'];

/**
 * Пора ли предупреждать. Порог — «не больше», а не «ровно»: тик таймера в фоновой вкладке
 * браузер троттлит и 120 можно перепрыгнуть, а зашедший на 90-й секунде клиент иначе не увидел
 * бы попап никогда. Одноразовость держит вызывающий — здесь только условие момента.
 */
export const shouldWarnLowTime = (
  transaction: any,
  timeLeft: number | null,
  showConfirm: boolean,
): boolean => {
  if (!transaction || showConfirm) return false;
  if (!REQUISITE_STATUSES.includes(transaction.status)) return false;
  if (transaction.simpleConfirmation !== false) return false;
  if (transaction.receiptIntent) return false;
  if (timeLeft === null) return false;

  return timeLeft > 0 && timeLeft <= LOW_TIME_WARNING_SEC;
};
